import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const BodyContainer = styled.div`
  max-width: 1057px;
  margin: auto;
  margin-top: 38px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 49px;
`;

const BottomButtonsContainer = styled.div`
  display: flex;
  margin-top: 49px;
  justify-content: flex-end;
  align-items: center;
`;

const DeleteContainer = styled.div`
  color: ${Colors.notification_failed};
  padding: 5px;
  margin-right: 40px;
  cursor: pointer;
`;

const SectionTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: ${Colors.primary};
`;
const Line = styled.div`
  background: ${Colors.background_dividers};
  height: 1px;
  width: 100%;
`;

export default {
  BodyContainer,
  BottomButtonsContainer,
  DeleteContainer,
  SectionTitle,
  Line,
};
